import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';

interface AlertBarProps {
  message: string | React.ReactNode;
  onClose?: () => void;
}

const AlertBarView = ({ message, onClose }: AlertBarProps) => (
  <Box
    sx={{
      backgroundColor: '#3D6F7B',
      width: '100%',
      position: 'sticky',
      top: { mobile: 77, desktop: 92 },
      zIndex: (theme) => theme.zIndex.appBar - 1,
    }}
  >
    <Box
      sx={{
        maxWidth: (theme) => theme.breakpoints.values.xl,
        width: '100%',
        mx: 'auto',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        px: { mobile: 3, desktop: 10 },
        py: { mobile: 1.5, desktop: 2 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: { mobile: 'flex-start', desktop: 'center' },
          gap: 1,
          flex: 1,
        }}
      >
        <Box
          sx={{
            width: 24,
            height: 24,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
          }}
        >
          <OutlinedIcons.OutlinedInformationCircleIcon sx={{ fontSize: 24 }} />
        </Box>
        <Typography
          sx={{
            color: 'white',
            fontSize: 16,
            fontWeight: 500,
            lineHeight: '24px',
          }}
        >
          {message}
        </Typography>
      </Box>
      {onClose && (
        <IconButton
          onClick={onClose}
          sx={{
            color: 'white',
            p: 0,
            '&:hover': {
              backgroundColor: 'transparent',
            },
          }}
          aria-label="Close alert"
        >
          <OutlinedIcons.OutlinedXIcon sx={{ fontSize: 24 }} />
        </IconButton>
      )}
    </Box>
  </Box>
);

export default AlertBarView;
